<template>
	<div>
		<el-dialog
			v-dialogDrag
			class="batch-force-import-dialog"
			:title="'批量强加，导入好友关系'"
			:visible.sync="visible"
			width="510px"
			:close-on-click-modal="false"
			:destroy-on-close="true"
			@close="onClose"
		>
			<div class="batch-force-import">
				<div class="upload-panel">
					<el-upload
						ref="upload"
						class="upload-box"
						:action="'#'"
						:drag="true"
						:multiple="false"
						:auto-upload="false"
						:limit="1"
						:accept="accept"
						:on-change="onFileChange"
						:on-exceed="onExceed"
					>
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
					</el-upload>

					<div class="tip-row">
						<span>仅允许导入xls、xlsx格式文件，</span>
						<span class="download-link" :class="{ loading: downloadLoading }" @click="downloadTemplate">
							<i v-if="downloadLoading" class="el-icon-loading"></i>
							下载模板
						</span>
					</div>

				</div>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="onClose">取消</el-button>
				<el-button type="primary" :loading="loading" @click="submit">确定</el-button>
			</span>
		</el-dialog>

		<el-dialog
			v-dialogDrag
			class="batch-force-import-result-dialog"
			:title="'导入结果'"
			:visible.sync="resultVisible"
			width="560px"
			:close-on-click-modal="false"
			:destroy-on-close="true"
			@close="closeResult"
		>
			<div class="result-panel">
				<div class="result-card success">
					<div class="num">{{ resultData.updateCount }}</div>
					<div class="label">更新好友</div>
				</div>
				<div class="result-card info">
					<div class="num">{{ resultData.successCount }}</div>
					<div class="label">导入成功</div>
				</div>
				<div class="result-card warning">
					<div class="num">{{ resultData.failCount }}</div>
					<div class="label">导入失败</div>
				</div>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="closeResult">关闭</el-button>
				<el-button type="primary" @click="closeResult">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import axios from 'axios';
import i18n from '@/i18n';

export default {
	name: 'batch-force-import',
	data() {
		return {
			visible: false,
			resultVisible: false,
			loading: false,
			downloadLoading: false,
			rawFile: null,
			accept: '.xls,.xlsx',
			resultData: {
				updateCount: 0,
				successCount: 0,
				failCount: 0
			}
		}
	},
	methods: {
		open() {
			this.reset();
			this.visible = true;
		},
		onClose() {
			this.visible = false;
			this.reset();
		},
		closeResult() {
			this.resultVisible = false;
			this.reset();
		},
		reset() {
			this.loading = false;
			this.rawFile = null;
			if (this.$refs.upload) {
				this.$refs.upload.clearFiles();
			}
		},
		onExceed() {
			this.$message.warning('一次只能选择一个文件');
		},
		onFileChange(file) {
			const isExcel = /\.(xls|xlsx)$/i.test(file.name);
			if (!isExcel) {
				this.$message.error('只能上传 xls、xlsx 格式文件');
				this.$refs.upload && this.$refs.upload.clearFiles();
				this.rawFile = null;
				return;
			}
			this.rawFile = file.raw;
		},
		async downloadTemplate() {
			if (this.downloadLoading) {
				return;
			}
			this.downloadLoading = true;
			try {
				const response = await axios.get(`${process.env.VUE_APP_BASE_API || ''}/friend/forceImport/template`, {
					responseType: 'blob',
					headers: this.getHeaders()
				});
				const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/octet-stream' });
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = this.getDownloadName(response.headers['content-disposition']);
				a.click();
				window.URL.revokeObjectURL(url);
			} catch (e) {
				this.$message.error('模板下载失败');
			} finally {
				this.downloadLoading = false;
			}
		},
		getDownloadName(contentDisposition) {
			if (!contentDisposition) {
				return '好友关系导入模板.xlsx';
			}
			const match = contentDisposition.match(/filename\*=UTF-8''([^;]+)|filename=([^;]+)/i);
			if (match) {
				return decodeURIComponent(match[1] || match[2]).replace(/"/g, '');
			}
			return '好友关系导入模板.xlsx';
		},
		getHeaders() {
			const accessToken = sessionStorage.getItem('accessToken');
			const locale = i18n.locale;
			const headers = {
				'Accept-Language': locale,
				'X-Locale': locale
			};
			if (accessToken) {
				headers.accessToken = encodeURIComponent(accessToken);
			}
			return headers;
		},
		normalizeResult(data) {
			return {
				updateCount: data?.updatedFriendCount ?? 0,
				successCount: data?.successCount ?? 0,
				failCount: data?.failCount ?? 0
			};
		},
		async submit() {
			if (!this.rawFile) {
				this.$message.warning('请先选择文件');
				return;
			}
			const formData = new FormData();
			formData.append('file', this.rawFile);
			this.loading = true;
			try {
				const data = await this.$http({
					url: '/friend/forceImport',
					method: 'post',
					data: formData,
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				});
				this.resultData = this.normalizeResult(data || {});
				this.visible = false;
				this.resultVisible = true;
				this.$message.success('导入完成');
			} finally {
				this.loading = false;
			}
		}
	}
}
</script>

<style scoped lang="scss">
.batch-force-import {
	.upload-panel {
		padding-top: 8px;
	}

	.upload-box {
		width: 100%;
		:deep(.el-upload-list) {
			text-align: left;
		}
	}

	:deep(.el-upload-dragger) {
		width: 468px;
		height: 230px;
		border-radius: 10px;
		border: 1px solid #ebeef5;
		background: #fff;
	}

	:deep(.el-upload-dragger:hover) {
		border-color: var(--im-color-primary);
	}

	:deep(.el-icon-upload) {
		margin-top: 58px;
		font-size: 64px;
		color: #b7c0d1;
	}

	:deep(.el-upload__text) {
		margin-top: 18px;
		font-size: 14px;
		color: var(--im-text-color-primary);
	}

	.tip-row {
		margin-top: 18px;
		text-align: center;
		font-size: 14px;
		color: var(--im-text-color-light);

		.download-link {
			color: var(--im-color-primary);
			cursor: pointer;
			display: inline-flex;
			align-items: center;
			gap: 4px;
		}

		.download-link.loading {
			pointer-events: none;
			opacity: 0.7;
		}
	}
}

.result-panel {
	display: flex;
	gap: 16px;
	justify-content: space-between;
	padding: 8px 0 12px;

	.result-card {
		flex: 1;
		border-radius: 8px;
		padding: 24px 10px 18px;
		text-align: center;
		background: #f7fbff;

		.num {
			font-size: 30px;
			font-weight: 600;
			line-height: 1;
		}

		.label {
			margin-top: 12px;
			font-size: 14px;
		}

		&.success {
			background: #ecfaf4;

			.num,
			.label {
				color: #1fbf75;
			}
		}

		&.info {
			background: #edf4ff;

			.num,
			.label {
				color: #4d7cff;
			}
		}

		&.warning {
			background: #fff5ee;

			.num,
			.label {
				color: #ff9a3c;
			}
		}
	}
}
</style>
